import { useCallback } from 'react'
import { AdminAPI } from '@guestgoodie/graphql'
import { useMutation } from '@apollo/client'

import Button from '@/components/ui/Button'
import { Step } from '../hooks/usePmsSteps'
import { ApolloErrorMessage } from '@/components/ui/ApolloErrorMessage'
import { useLingui } from '@lingui/react/macro'

export function ButtonComponent({ step }: { step: Step }) {
  const { t } = useLingui()
  const [finishStep, { error, loading }] = useMutation(AdminAPI.pms.FINISH_STEP)

  const onSubmit = useCallback(() => {
    finishStep({
      variables: {
        data: JSON.stringify({})
      }
    })
  }, [finishStep])

  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-heading1 text-text">{step.title}</h1>
      {step.description && (
        <p className="text-regular text-text">{step.description}</p>
      )}
      <div className="flex flex-col gap-1 p-4">
        <Button onClick={onSubmit} className="w-full" loading={loading}>
          {step.buttonLabel}
        </Button>
        <ApolloErrorMessage
          error={error}
          messageTranslations={{
            credential_error: t`There was an issue with the credentials. Did you complete all steps successfully?`
          }}
        />
      </div>
    </div>
  )
}
